import { call, put } from 'redux-saga/effects';
import {
  docSignLinkRequest,
  docSignLinkSuccess,
  docSignLinkFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* sendDocumentSignLinkByUser(action) {
  yield put(docSignLinkRequest());
  const patientId = action.payload.param.patientId;
  try {
    const result = yield call(
      Api.post,
      `${urls.aspariaBackend}api/v1/patient/sendDocSignLink/${patientId}`
    );
    if (result) {
      action.callback(result.data.data);
      yield put(docSignLinkSuccess());
    } else {
      yield put(docSignLinkFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(docSignLinkFailure(e));
  }
}

export const sendDocumentSignLinkSagaAction = (param, cb) => ({
  type: SagaTypes.SEND_DOC_SIGN_LINK_TO_PATIENT,
  payload: { param },
  callback: cb,
});
